import { CssBaseline, ThemeProvider } from '@material-ui/core'
import type { ReactNode } from 'react'
import React, { useMemo } from 'react'
import { useClientOptions } from '../../providers/ClientOptionsProvider'
import CustomCss from '../CustomCss'
import { useUser } from '../../providers/UserProvider'
import { getTheme } from './get-theme'

/**
 * Creates a ThemeProvider using the options from ClientOptionsProvider
 */
export default function Theme({ children, customerFacing }: { children: ReactNode; customerFacing?: boolean }) {
  const { options } = useClientOptions()
  const { preferences, isMasquerading } = useUser()

  const theme = useMemo(
    () =>
      getTheme({
        options,
        preferences,
        removePrimaryColor: !customerFacing
      }),
    [
      options && options.options.primaryColor.value,
      options && options.options.secondaryColor.value,
      preferences && preferences.fontScale,
      isMasquerading
    ]
  )

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <CustomCss />
      {children}
    </ThemeProvider>
  )
}
